<template>
  <div>
    <title-edit header="Restaurant" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="6"  xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="6"  xs="12">
        <select-option :model="form.branch_id" :items="optionBranch" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Upload file* :</label>
      </v-col>
      <v-col cols="12" sm="9"  xs="12">
        <v-row>
          <v-col cols="12" md="8">
            <input-upload-file :label="form.download_url" @update="updateDownloadUrl" />
          </v-col>
          <v-col cols="12" md="2">
            <submit-button label="preview" @click.native="downloadUrl" />
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-row>
          <v-col cols="12" md="10">
            <input-editor :model="form.description_th" @update="updateDescriptionTH" />
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-row>
          <v-col cols="12" md="10">
            <input-editor :model="form.description_en" @update="updateDescriptionEN" />
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Image :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-row>
          <v-col cols="12" md="10">
            <input-image-upload id="image1" :model="form.image_url_show" width="300px" height="200px" @update="updateImageUrl" />
          </v-col>
        </v-row>
      </v-col>
    </div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" align="center" justify="center">
        <submit-button label="+ restaurant" @click.native="showRestaurantDetails(null)" />
      </v-col>
    </v-row>
    <div class="row justify-center d-flex">
      <v-col sm="1"></v-col>
      <v-col cols="12" sm="9">
        <v-simple-table class="branch-data">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center" v-for="header in headers" :key="header.id">
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in restaurantDetails" :key="data.id">
                <td width="100px">{{ ++index }}</td>
                <td width="100px">{{ data.name_th }}</td>
                <td width="100px">{{ data.name_en }}</td>
                <td width="100px">{{ data.lat }}</td>
                <td width="100px">{{ data.lon }}</td>
                <td width="100px">{{ data.location }}</td>
                <td width="100px">
                  <a @click="showRestaurantDetails(data)">
                    <v-icon class="fas fa-pencil-alt pencil"></v-icon> </a
                  >&nbsp;
                  <a @click="deleteRestaurantDetails(index - 1)">
                    <v-icon class="fas fa-trash pencil"></v-icon>
                  </a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col sm="2"></v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteRestaurant" @save-info="saveRestaurant" @save-close="saveClose"></command-button>
    <v-dialog v-model="dialog" scrollable max-width="500px">
      <create-restaurant-modal :form="detail" @update="addRestaurantDetails">
      </create-restaurant-modal>
    </v-dialog>
    <!--    <pre>{{restaurantDetails}}</pre>-->
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import InputTextField from "../../../components/Input/InputTextField";
import SelectOption from "../../../components/Input/selectOption";
import InputEditor from "../../../components/Input/InputEditor";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import { mapState } from "vuex";
import SubmitButton from "../../../components/Button/SubmitButton";
import InputUploadFile from "../../../components/Input/InputUploadFile";
import InputTextArea from "../../../components/Input/InputTextArea";
import CreateRestaurantModal from "./CreateRestaurantModal";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import {permissionRestaurant, role} from "../../../util/Permission";
import Swal from "sweetalert";
import CommandButton from "../../../components/Layout/CommandButton";

export default {
  name: "RestaurantEdit",
  components: {
    CommandButton,
    IconPencil,
    CircleButton,
    CreateRestaurantModal,
    InputTextArea,
    InputUploadFile,
    SubmitButton,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputImageUpload,
    InputEditor,
    SelectOption,
    InputTextField,
    LineHr,
    TitleEdit
  },
  computed: {
    permissionRestaurant,
    ...mapState({
      form: state => {
        return state.Restaurant.form;
      }
    })
  },
  data() {
    return {
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Name TH" },
        { id: 3, text: "Name EN" },
        { id: 4, text: "Latitude" },
        { id: 5, text: "Longitude" },
        { id: 6, text: "Address" },
        { id: 7, text: "Edit" }
      ],
      optionBranch: [],
      restaurantDetails: [],
      dialog: false,
      detail: {
        id: "",
        name_th: "",
        name_en: "",
        lat: "",
        lon: "",
        location: ""
      },
      permission : null,
      save_id: null
    };
  },
  created() {
    this.permission = role;
    this.getBranchData();
    this.restaurantDetails = this.form.restaurant_details;
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    validateSave() {
      if (!this.form.branch_id) {
        Swal('','Please select Branch !','error');
        return false;
      } else {
        return true;
      }
    },
    saveClose() {
      if (this.validateSave()) {
        this.form.restaurant_details = this.restaurantDetails;
        this.$store
                .dispatch("Restaurant/saveRestaurant", {
                  id: this.save_id ? this.save_id : this.form.id,
                  data: this.form
                })
                .then(res => {
                  Swal(res.response_msg);
                  if (res.response_code == 200) {
                    this.goToRestaurantTable();
                  }
                })
                .catch(() => {
                  Swal('','Cannot save restaurant data!','error');
                });
      }
    },
    saveRestaurant() {
      if (this.validateSave()) {
        this.form.restaurant_details = this.restaurantDetails;
        this.$store
          .dispatch("Restaurant/saveRestaurant", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            this.save_id = res.result.id;
            Swal(res.response_msg);
          })
          .catch(() => {
            Swal('','Cannot save restaurant data!','error');
          });
      }
    },
    addRestaurantDetails(val) {
      let data = "";
      if (val && !val.id) {
        data = val;
        this.restaurantDetails.push(data);
      }
      this.detail = {
        name_th: "",
        name_en: "",
        lat: "",
        lon: "",
        location: ""
      };
      this.dialog = false;
    },
    showRestaurantDetails(item) {
      if (item) {
        this.detail = item;
      }
      this.dialog = true;
    },
    deleteRestaurantDetails(index) {
      this.restaurantDetails = this.restaurantDetails.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    },
    deleteRestaurant() {
      this.$store
        .dispatch("Restaurant/deleteRestaurant", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToRestaurantTable();
          }
        })
        .catch(() => {
          Swal('','Cannot delete restaurant data!','error');
        });
    },
    goToRestaurantTable() {
      this.$router.push("/services/restaurant");
    },
    downloadUrl() {
      if (this.form.download_url_show) {
        window.open(this.form.download_url_show, "_blank");
      } else {
        Swal('','File not found for download','error');
      }
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateImageUrl(val) {
      this.form.image_url = val.imagePath;
      this.form.image_url_show = val.fullImagePath;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDownloadUrl(val) {
      this.form.download_url = val.path;
      this.form.download_url_show = val.fullPath;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/switch.css";
@import "../../../assets/css/variables";
.pencil {
  color: $submit-color;
  font-size: 20px;
}
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
